import { useState } from "react";
import { faCircleMinus, faCirclePlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Faqs from "@/lib/faqs";

export default function Faq () {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);

  return (
    <section className="border-b-[1px] border-orange-light relative mx-auto py-4 px-8 bigscreen-responsive gap-8">
      <div className="flex justify-center relative py-8 md:py-16">
        <div className="w-full max-w-4xl items-center text-center px-4">
          <h4 className="mb-8 text-orange text-xl font-bold px-6 py-2 uppercase">FAQ</h4>
          <h5 className="text-center text-xl font-bold mb-8 md:text-3xl">¿Tenés preguntas?</h5>
          <div className="flex flex-col gap-8">
            {Faqs.map(faq => ( 
              <div key={faq.id} onClick={() => setOpenQuestion(openQuestion === faq.id ? null : faq.id)} className="w-full rounded-xl border border-gray-100 shadow-md overflow-hidden py-8 hover:cursor-pointer">
                <div className="flex items-center justify-between text-left font-bold text-sm px-6 md:text-lg">
                  <p> { faq.question } </p>
                  <FontAwesomeIcon icon={openQuestion === faq.id ? faCircleMinus : faCirclePlus} className="text-yellow text-2xl cursor-pointer hover:text-yellow/75"/>
                </div>
                { openQuestion === faq.id && (
                  <p className="text-left text-sm text-[#637381] px-8 mt-2 max-w-2xl"> { faq.answer } </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
